// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/src/Css.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Antd$BwaxAdmin = require("../binding/antd/Antd.bs.js");
var Json$BwaxAdmin = require("../../../lib/bwax-js/ml/utils/json.bs.js");
var Plate$BwaxAdmin = require("../../../lib/bwax-js/ml/plate.bs.js");
var BaseUI$BwaxAdmin = require("../../../lib/bwax-ui/re/BaseUI.bs.js");
var Message = require("antd/lib/message");
var Caml_chrome_debugger = require("bs-platform/lib/js/caml_chrome_debugger.js");
var QueryRunner$BwaxAdmin = require("../../../lib/bwax-js/re/binding/QueryRunner.bs.js");
var Popconfirm = require("bwax-ui/components/Popconfirm");
var DataLoaderContext = require("bwax-ui/store/DataLoaderContext");

var text = "\n        query {\n          sandboxDefinitionChanges {\n            hasChange\n            dataEntities {\n              hasChange\n              added {\n                name\n              }\n              updated {\n                record {\n                  name\n                }\n              }\n              deleted {\n                name\n              }\n            }\n            dataTypes {\n              hasChange\n              added {\n                name\n              }\n              updated {\n                record {\n                  name\n                }\n              }\n              deleted {\n                name\n              }\n            }\n            eventHandlers {\n              hasChange\n              added {\n                name\n              }\n              updated {\n                record {\n                  name\n                }\n              }\n              deleted {\n                name\n              }\n            }\n            scheduledEventHandlers {\n              hasChange\n              added {\n                name\n              }\n              updated {\n                record {\n                  name\n                }\n              }\n              deleted {\n                name\n              }\n            }\n            pages {\n              hasChange\n              added {\n                name\n              }\n              updated {\n                record {\n                  name\n                }\n              }\n              deleted {\n                name\n              }\n            }\n            pageRedirects {\n              hasChange\n              added {\n                name\n              }\n              updated {\n                record {\n                  name\n                }\n              }\n              deleted {\n                name\n              }\n            }\n\n            pageFragments {\n              hasChange\n              added {\n                name\n              }\n              updated {\n                record {\n                  name\n                }\n              }\n              deleted {\n                name\n              }\n            }            \n            pageComponents {\n              hasChange\n              added {\n                name\n              }\n              updated {\n                record {\n                  name\n                }\n              }\n              deleted {\n                name\n              }\n            }               \n            adminPages {\n              hasChange\n              added {\n                name\n              }\n              updated {\n                record {\n                  name\n                }\n              }\n              deleted {\n                name\n              }\n            }\n                        \n            theme {\n              hasChange\n            }\n            generalSettings {\n              hasChange\n              added {\n                name\n              }\n              updated {\n                record {\n                  name\n                }\n              }\n              deleted {\n                name\n              }\n            }\n          }\n        }\n    ";

var QuerySandboxDefinitionChanges = {
  text: text
};

var text$1 = "\n          mutation($input: PublishDefinitionInput!) {\n              publishDefinition(input: $input) {\n                  publishedVersion {\n                      name\n                  }\n              }\n          }\n      ";

var MutPublishDefinition = {
  text: text$1
};

function json_to_changes(json) {
  var get_list = function (name, json) {
    return Plate$BwaxAdmin.$$Option.with_default(/* [] */0, Plate$BwaxAdmin.$$Option.map(Plate$BwaxAdmin.List.from_array, Json$BwaxAdmin.get_value(name, Js_json.decodeArray, json)));
  };
  var added = Plate$BwaxAdmin.List.keep_map((function (param) {
          return Json$BwaxAdmin.get_value("name", Js_json.decodeString, param);
        }), get_list("added", json));
  var partial_arg = /* :: */Caml_chrome_debugger.simpleVariant("::", [
      "record",
      /* :: */Caml_chrome_debugger.simpleVariant("::", [
          "name",
          /* [] */0
        ])
    ]);
  var updated = Plate$BwaxAdmin.List.keep_map(Js_json.decodeString, Plate$BwaxAdmin.List.keep_map((function (param) {
              return Json$BwaxAdmin.get_by_path(partial_arg, param);
            }), get_list("updated", json)));
  var partial_arg$1 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
      "name",
      /* [] */0
    ]);
  var deleted = Plate$BwaxAdmin.List.keep_map(Js_json.decodeString, Plate$BwaxAdmin.List.keep_map((function (param) {
              return Json$BwaxAdmin.get_by_path(partial_arg$1, param);
            }), get_list("deleted", json)));
  return /* record */Caml_chrome_debugger.record([
            "added",
            "updated",
            "deleted"
          ], [
            added,
            updated,
            deleted
          ]);
}

function maybe_json_to_changes(mj) {
  if (mj !== undefined) {
    return json_to_changes(Caml_option.valFromOption(mj));
  } else {
    return /* record */Caml_chrome_debugger.record([
              "added",
              "updated",
              "deleted"
            ], [
              0,
              0,
              0
            ]);
  }
}

function PublishPage(Props) {
  var disabled = Props.disabled;
  var match = React.useState((function () {
          return false;
        }));
  var setInProgress = match[1];
  var inProgress = match[0];
  var match$1 = React.useState((function () {
          return false;
        }));
  var setHasChange = match$1[1];
  var match$2 = React.useState((function () {
          return /* [] */0;
        }));
  var setVersionChanges = match$2[1];
  var versionChanges = match$2[0];
  var handleResult = function (json) {
    var hasChange = Plate$BwaxAdmin.$$Option.with_default(false, Json$BwaxAdmin.get_value("hasChange", Js_json.decodeBoolean, json));
    Plate$BwaxAdmin.$$Option.with_default(false, Plate$BwaxAdmin.$$Option.and_then(Js_json.decodeBoolean, Json$BwaxAdmin.get_by_path(/* :: */Caml_chrome_debugger.simpleVariant("::", [
                    "theme",
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        "hasChange",
                        /* [] */0
                      ])
                  ]), json)));
    var version_changes = Plate$BwaxAdmin.List.assoc_map((function (n) {
            return maybe_json_to_changes(Json$BwaxAdmin.get_field(n, json));
          }), /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* tuple */[
              "数据实体",
              "dataEntities"
            ],
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                /* tuple */[
                  "数据类型",
                  "dataTypes"
                ],
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    /* tuple */[
                      "H5页面",
                      "pages"
                    ],
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        /* tuple */[
                          "页面跳转",
                          "pageRedirects"
                        ],
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            /* tuple */[
                              "页面片段",
                              "pageFragments"
                            ],
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* tuple */[
                                  "页面组件",
                                  "pageComponents"
                                ],
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    /* tuple */[
                                      "后台页面",
                                      "adminPages"
                                    ],
                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                        /* tuple */[
                                          "事件处理",
                                          "eventHandlers"
                                        ],
                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                            /* tuple */[
                                              "定时事件处理",
                                              "scheduledEventHandlers"
                                            ],
                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                /* tuple */[
                                                  "通用设定",
                                                  "generalSettings"
                                                ],
                                                /* [] */0
                                              ])
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ])
                  ])
              ])
          ]));
    Curry._1(setVersionChanges, (function (param) {
            return version_changes;
          }));
    return Curry._1(setHasChange, (function (param) {
                  return hasChange;
                }));
  };
  var dlc = React.useContext(DataLoaderContext.default);
  var env = QueryRunner$BwaxAdmin.toEnv(dlc);
  var queryChange = function (param) {
    QueryRunner$BwaxAdmin.queryDefinition(Caml_option.some(env), text, undefined, undefined, /* () */0).then((function (value) {
            var partial_arg = /* :: */Caml_chrome_debugger.simpleVariant("::", [
                "data",
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    "sandboxDefinitionChanges",
                    /* [] */0
                  ])
              ]);
            var result = Plate$BwaxAdmin.$$Option.and_then((function (param) {
                    return Json$BwaxAdmin.get_by_path(partial_arg, param);
                  }), Json$BwaxAdmin.parse(value));
            if (result !== undefined) {
              handleResult(Caml_option.valFromOption(result));
            }
            return Promise.resolve(/* () */0);
          }));
    return /* () */0;
  };
  React.useEffect((function () {
          queryChange(/* () */0);
          return ;
        }), ([]));
  var publish = function (param) {
    Curry._1(setInProgress, (function (param) {
            return true;
          }));
    QueryRunner$BwaxAdmin.queryDefinition(undefined, text$1, Caml_option.some(Js_dict.fromList(/* :: */Caml_chrome_debugger.simpleVariant("::", [
                      /* tuple */[
                        "input",
                        Js_dict.fromList(/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* tuple */[
                                  "clientMutationId",
                                  Date.now().toString()
                                ],
                                /* [] */0
                              ]))
                      ],
                      /* [] */0
                    ]))), undefined, /* () */0).then((function (value) {
            var partial_arg = /* :: */Caml_chrome_debugger.simpleVariant("::", [
                "data",
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    "publishDefinition",
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        "publishedVersion",
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            "name",
                            /* [] */0
                          ])
                      ])
                  ])
              ]);
            var name = Plate$BwaxAdmin.$$Option.with_default("", Plate$BwaxAdmin.$$Option.and_then(Js_json.decodeString, Plate$BwaxAdmin.$$Option.and_then((function (param) {
                            return Json$BwaxAdmin.get_by_path(partial_arg, param);
                          }), Json$BwaxAdmin.parse(value))));
            Message.default.success("你发布了新的版本 " + (String(name) + ""), undefined, undefined);
            Curry._1(setInProgress, (function (param) {
                    return false;
                  }));
            Curry._1(setHasChange, (function (param) {
                    return false;
                  }));
            return Promise.resolve(/* () */0);
          }));
    return /* () */0;
  };
  var doHaveChange = function (changes) {
    return Plate$BwaxAdmin.List.sum(Plate$BwaxAdmin.List.map(Plate$BwaxAdmin.List.length, /* :: */Caml_chrome_debugger.simpleVariant("::", [
                      changes[/* added */0],
                      /* :: */Caml_chrome_debugger.simpleVariant("::", [
                          changes[/* updated */1],
                          /* :: */Caml_chrome_debugger.simpleVariant("::", [
                              changes[/* deleted */2],
                              /* [] */0
                            ])
                        ])
                    ]))) > 0;
  };
  var renderChange = function (param) {
    var changes = param[1];
    var name = param[0];
    console.log(name, changes);
    if (doHaveChange(changes)) {
      var partial_arg = /* :: */Caml_chrome_debugger.simpleVariant("::", [
          /* textBold */-1005136686,
          /* :: */Caml_chrome_debugger.simpleVariant("::", [
              /* `textSize */Caml_chrome_debugger.polyVar("textSize", [
                  -816909298,
                  /* `px */Caml_chrome_debugger.polyVar("px", [
                      25096,
                      14
                    ])
                ]),
              /* :: */Caml_chrome_debugger.simpleVariant("::", [
                  /* `backgroundColor */Caml_chrome_debugger.polyVar("backgroundColor", [
                      222776981,
                      /* N20 */3890060
                    ]),
                  /* :: */Caml_chrome_debugger.simpleVariant("::", [
                      /* `paddingXY */Caml_chrome_debugger.polyVar("paddingXY", [
                          -303792878,
                          /* tuple */[
                            /* `rem */Caml_chrome_debugger.polyVar("rem", [
                                5691738,
                                1.0
                              ]),
                            /* `rem */Caml_chrome_debugger.polyVar("rem", [
                                5691738,
                                0.5
                              ])
                          ]
                        ]),
                      /* :: */Caml_chrome_debugger.simpleVariant("::", [
                          /* `width */Caml_chrome_debugger.polyVar("width", [
                              -899500538,
                              /* fill */-1011102077
                            ]),
                          /* [] */0
                        ])
                    ])
                ])
            ])
        ]);
      var title = function (param, param$1, param$2, param$3) {
        return BaseUI$BwaxAdmin.text(partial_arg, name, param, param$1, param$2, param$3);
      };
      var changesRow = function (label, l) {
        if (Plate$BwaxAdmin.List.length(l) > 0) {
          var partial_arg = /* :: */Caml_chrome_debugger.simpleVariant("::", [
              /* `width */Caml_chrome_debugger.polyVar("width", [
                  -899500538,
                  /* `rem */Caml_chrome_debugger.polyVar("rem", [
                      5691738,
                      4.0
                    ])
                ]),
              /* :: */Caml_chrome_debugger.simpleVariant("::", [
                  /* `paddingXY */Caml_chrome_debugger.polyVar("paddingXY", [
                      -303792878,
                      /* tuple */[
                        /* `rem */Caml_chrome_debugger.polyVar("rem", [
                            5691738,
                            1.0
                          ]),
                        /* `rem */Caml_chrome_debugger.polyVar("rem", [
                            5691738,
                            0.25
                          ])
                      ]
                    ]),
                  /* [] */0
                ])
            ]);
          var labelText = function (param, param$1, param$2, param$3) {
            return BaseUI$BwaxAdmin.text(partial_arg, label, param, param$1, param$2, param$3);
          };
          var showValue = function (v) {
            return (function (param, param$1, param$2, param$3) {
                return BaseUI$BwaxAdmin.text(/* [] */0, v, param, param$1, param$2, param$3);
              });
          };
          var partial_arg$1 = Plate$BwaxAdmin.List.map(showValue, l);
          var partial_arg$2 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
              /* `borderWidthEach */Caml_chrome_debugger.polyVar("borderWidthEach", [
                  -34049893,
                  /* record */Caml_chrome_debugger.record([
                      "top",
                      "right",
                      "bottom",
                      "left"
                    ], [
                      /* `px */Caml_chrome_debugger.polyVar("px", [
                          25096,
                          0
                        ]),
                      /* zero */-789508312,
                      /* zero */-789508312,
                      /* `px */Caml_chrome_debugger.polyVar("px", [
                          25096,
                          1
                        ])
                    ])
                ]),
              /* :: */Caml_chrome_debugger.simpleVariant("::", [
                  /* `borderColor */Caml_chrome_debugger.polyVar("borderColor", [
                      -690668329,
                      /* N20 */3890060
                    ]),
                  /* :: */Caml_chrome_debugger.simpleVariant("::", [
                      /* `width */Caml_chrome_debugger.polyVar("width", [
                          -899500538,
                          /* fill */-1011102077
                        ]),
                      /* :: */Caml_chrome_debugger.simpleVariant("::", [
                          /* `spacing */Caml_chrome_debugger.polyVar("spacing", [
                              297481091,
                              /* `rem */Caml_chrome_debugger.polyVar("rem", [
                                  5691738,
                                  0.5
                                ])
                            ]),
                          /* :: */Caml_chrome_debugger.simpleVariant("::", [
                              /* `padding */Caml_chrome_debugger.polyVar("padding", [
                                  -797091375,
                                  /* `rem */Caml_chrome_debugger.polyVar("rem", [
                                      5691738,
                                      1.0
                                    ])
                                ]),
                              /* [] */0
                            ])
                        ])
                    ])
                ])
            ]);
          var values = function (param, param$1, param$2, param$3) {
            return BaseUI$BwaxAdmin.wrappedRow(partial_arg$2, partial_arg$1, param, param$1, param$2, param$3);
          };
          var partial_arg_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
              values,
              /* [] */0
            ]);
          var partial_arg$3 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
              labelText,
              partial_arg_001
            ]);
          var partial_arg$4 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
              /* `width */Caml_chrome_debugger.polyVar("width", [
                  -899500538,
                  /* fill */-1011102077
                ]),
              /* :: */Caml_chrome_debugger.simpleVariant("::", [
                  /* `borderWidthEach */Caml_chrome_debugger.polyVar("borderWidthEach", [
                      -34049893,
                      /* record */Caml_chrome_debugger.record([
                          "top",
                          "right",
                          "bottom",
                          "left"
                        ], [
                          /* `px */Caml_chrome_debugger.polyVar("px", [
                              25096,
                              0
                            ]),
                          /* `px */Caml_chrome_debugger.polyVar("px", [
                              25096,
                              1
                            ]),
                          /* `px */Caml_chrome_debugger.polyVar("px", [
                              25096,
                              1
                            ]),
                          /* `px */Caml_chrome_debugger.polyVar("px", [
                              25096,
                              1
                            ])
                        ])
                    ]),
                  /* :: */Caml_chrome_debugger.simpleVariant("::", [
                      /* `borderColor */Caml_chrome_debugger.polyVar("borderColor", [
                          -690668329,
                          /* N20 */3890060
                        ]),
                      /* [] */0
                    ])
                ])
            ]);
          return (function (param, param$1, param$2, param$3) {
              return BaseUI$BwaxAdmin.row(partial_arg$4, partial_arg$3, param, param$1, param$2, param$3);
            });
        } else {
          return BaseUI$BwaxAdmin.empty;
        }
      };
      var partial_arg_000 = changesRow("新增", changes[/* added */0]);
      var partial_arg_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
          changesRow("修改", changes[/* updated */1]),
          /* :: */Caml_chrome_debugger.simpleVariant("::", [
              changesRow("删除", changes[/* deleted */2]),
              /* [] */0
            ])
        ]);
      var partial_arg$1 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
          partial_arg_000,
          partial_arg_001
        ]);
      var partial_arg$2 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
          /* `width */Caml_chrome_debugger.polyVar("width", [
              -899500538,
              /* fill */-1011102077
            ]),
          /* [] */0
        ]);
      var detailView = function (param, param$1, param$2, param$3) {
        return BaseUI$BwaxAdmin.column(partial_arg$2, partial_arg$1, param, param$1, param$2, param$3);
      };
      var partial_arg_001$1 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
          detailView,
          /* [] */0
        ]);
      var partial_arg$3 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
          title,
          partial_arg_001$1
        ]);
      var partial_arg$4 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
          /* `width */Caml_chrome_debugger.polyVar("width", [
              -899500538,
              /* fill */-1011102077
            ]),
          /* [] */0
        ]);
      return (function (param, param$1, param$2, param$3) {
          return BaseUI$BwaxAdmin.column(partial_arg$4, partial_arg$3, param, param$1, param$2, param$3);
        });
    } else {
      return BaseUI$BwaxAdmin.empty;
    }
  };
  var changesView;
  if (Plate$BwaxAdmin.List.some((function (param) {
            return doHaveChange(param[1]);
          }), versionChanges)) {
    var partial_arg = Plate$BwaxAdmin.List.map(renderChange, versionChanges);
    var partial_arg$1 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
        /* `height */Caml_chrome_debugger.polyVar("height", [
            38537191,
            /* fill */-1011102077
          ]),
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* `width */Caml_chrome_debugger.polyVar("width", [
                -899500538,
                /* fill */-1011102077
              ]),
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                /* `spacing */Caml_chrome_debugger.polyVar("spacing", [
                    297481091,
                    /* `rem */Caml_chrome_debugger.polyVar("rem", [
                        5691738,
                        1.0
                      ])
                  ]),
                /* [] */0
              ])
          ])
      ]);
    changesView = (function (param, param$1, param$2, param$3) {
        return BaseUI$BwaxAdmin.column(partial_arg$1, partial_arg, param, param$1, param$2, param$3);
      });
  } else {
    var partial_arg$2 = "目前没有未发布内容";
    var partial_arg$3 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
        /* centerX */434500835,
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* centerY */434500836,
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                /* `textColor */Caml_chrome_debugger.polyVar("textColor", [
                    -481689226,
                    /* lightText */-971527005
                  ]),
                /* [] */0
              ])
          ])
      ]);
    var partial_arg$4 = function (param, param$1, param$2, param$3) {
      return BaseUI$BwaxAdmin.text(partial_arg$3, partial_arg$2, param, param$1, param$2, param$3);
    };
    var partial_arg$5 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
        /* `width */Caml_chrome_debugger.polyVar("width", [
            -899500538,
            /* fill */-1011102077
          ]),
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* `height */Caml_chrome_debugger.polyVar("height", [
                38537191,
                /* `percent */Caml_chrome_debugger.polyVar("percent", [
                    -119887163,
                    50.0
                  ])
              ]),
            /* [] */0
          ])
      ]);
    changesView = (function (param, param$1, param$2, param$3) {
        return BaseUI$BwaxAdmin.box(partial_arg$5, partial_arg$4, param, param$1, param$2, param$3);
      });
  }
  var refresh = function (param) {
    return queryChange(/* () */0);
  };
  var partial_arg$6 = "刷新";
  var partial_arg$7 = !match$1[0] || inProgress || disabled;
  var partial_arg$8 = "您确定要发布当前的所有更改？";
  var partial_arg$9 = inProgress ? "发布中" : "发布";
  var partial_arg_000 = function (param, param$1, param$2, param$3) {
    var label = partial_arg$6;
    var onClick = refresh;
    var type_ = "default";
    var disabled = false;
    var key = param$3;
    return React.createElement(Antd$BwaxAdmin.Button.make, {
                type_: type_,
                disabled: disabled,
                onClick: onClick,
                children: label,
                key: key
              });
  };
  var partial_arg_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
      (function (param, param$1, param$2, param$3) {
          var label = partial_arg$9;
          var confirmText = partial_arg$8;
          var onClick = publish;
          var type_ = "primary";
          var disabled = partial_arg$7;
          var loading = inProgress;
          var key = param$3;
          if (disabled) {
            return React.createElement(Antd$BwaxAdmin.Button.make, {
                        type_: type_,
                        disabled: disabled,
                        children: label,
                        key: key
                      });
          } else {
            return Popconfirm.create({
                        key: key,
                        title: confirmText,
                        positions: /* array */[
                          "top",
                          "bottom"
                        ],
                        align: "start",
                        okText: "是",
                        cancelText: "否",
                        padding: 8,
                        onConfirm: Caml_option.some(onClick),
                        children: React.createElement("div", undefined, React.createElement(Antd$BwaxAdmin.Button.make, {
                                  type_: type_,
                                  loading: loading,
                                  children: label,
                                  key: key
                                }))
                      });
          }
        }),
      /* [] */0
    ]);
  var partial_arg$10 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
      partial_arg_000,
      partial_arg_001
    ]);
  var partial_arg$11 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
      /* `spacing */Caml_chrome_debugger.polyVar("spacing", [
          297481091,
          /* `rem */Caml_chrome_debugger.polyVar("rem", [
              5691738,
              1.0
            ])
        ]),
      /* :: */Caml_chrome_debugger.simpleVariant("::", [
          /* alignRight */45513431,
          /* [] */0
        ])
    ]);
  var toolbar = function (param, param$1, param$2, param$3) {
    return BaseUI$BwaxAdmin.row(partial_arg$11, partial_arg$10, param, param$1, param$2, param$3);
  };
  var className = Css.style(/* :: */Caml_chrome_debugger.simpleVariant("::", [
          Css.backgroundColor(Css.white),
          /* [] */0
        ]));
  return React.createElement("div", {
              className: "bw-ui lc-base" + className
            }, BaseUI$BwaxAdmin.column(/* :: */Caml_chrome_debugger.simpleVariant("::", [
                    /* `height */Caml_chrome_debugger.polyVar("height", [
                        38537191,
                        /* `percent */Caml_chrome_debugger.polyVar("percent", [
                            -119887163,
                            100.0
                          ])
                      ]),
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        /* `width */Caml_chrome_debugger.polyVar("width", [
                            -899500538,
                            /* fill */-1011102077
                          ]),
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            /* `maxWidth */Caml_chrome_debugger.polyVar("maxWidth", [
                                -192935742,
                                /* `rem */Caml_chrome_debugger.polyVar("rem", [
                                    5691738,
                                    64.0
                                  ])
                              ]),
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* `spacing */Caml_chrome_debugger.polyVar("spacing", [
                                    297481091,
                                    /* `rem */Caml_chrome_debugger.polyVar("rem", [
                                        5691738,
                                        1.0
                                      ])
                                  ]),
                                /* [] */0
                              ])
                          ])
                      ])
                  ]), /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    toolbar,
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        changesView,
                        /* [] */0
                      ])
                  ]), undefined, /* column */-963948842, /* [] */0, "publish-page"));
}

var make = PublishPage;

exports.QuerySandboxDefinitionChanges = QuerySandboxDefinitionChanges;
exports.MutPublishDefinition = MutPublishDefinition;
exports.json_to_changes = json_to_changes;
exports.maybe_json_to_changes = maybe_json_to_changes;
exports.make = make;
/* Css Not a pure module */
